import { useState } from "react";

const LEADERBOARD_DATA = [
  {
    rank: 1,
    teamName: "AI 드림팀",
    members: ["한예린", "정우진", "김수아", "이도현"],
    avatars: [
      "https://public.readdy.ai/ai/img_res/72cce63145268e0f5713adbb27d29d52.jpg",
      "https://readdy.ai/api/search-image?query=young%20korean%20male%20smiling%20casual%20portrait%20clean%20white%20background%20minimal%20headshot&width=40&height=40&seq=lb2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=young%20korean%20female%20bright%20smile%20portrait%20clean%20minimal%20background%20headshot&width=40&height=40&seq=lb3&orientation=squarish",
      "https://readdy.ai/api/search-image?query=young%20korean%20male%20casual%20portrait%20bright%20clean%20background%20headshot%20warm&width=40&height=40&seq=lb4&orientation=squarish",
    ],
    points: 4820,
    completedMissions: 8,
    badge: "👑",
    trend: "up",
  },
  {
    rank: 2,
    teamName: "프롬프트 마스터즈",
    members: ["박민준", "강하윤", "윤서준"],
    avatars: [
      "https://readdy.ai/api/search-image?query=young%20korean%20male%20smiling%20portrait%20bright%20clean%20background%20headshot%20warm&width=40&height=40&seq=lb5&orientation=squarish",
      "https://readdy.ai/api/search-image?query=young%20korean%20female%20bright%20smile%20casual%20portrait%20clean%20white%20background%20headshot&width=40&height=40&seq=lb6&orientation=squarish",
      "https://readdy.ai/api/search-image?query=young%20korean%20male%20casual%20smile%20portrait%20clean%20background%20minimal%20headshot&width=40&height=40&seq=lb7&orientation=squarish",
    ],
    points: 3960,
    completedMissions: 7,
    badge: "🥈",
    trend: "up",
  },
  {
    rank: 3,
    teamName: "뉴비지만열심히",
    members: ["임나영", "최민재"],
    avatars: [
      "https://readdy.ai/api/search-image?query=young%20korean%20female%20creative%20casual%20portrait%20minimal%20clean%20background%20headshot&width=40&height=40&seq=lb8&orientation=squarish",
      "https://readdy.ai/api/search-image?query=young%20korean%20male%20professional%20casual%20portrait%20minimal%20clean%20background%20headshot&width=40&height=40&seq=lb9&orientation=squarish",
    ],
    points: 2840,
    completedMissions: 5,
    badge: "🥉",
    trend: "same",
  },
  {
    rank: 4,
    teamName: "이미지 크리에이터스",
    members: ["박준혁", "이소연", "김지우"],
    avatars: [
      "https://readdy.ai/api/search-image?query=young%20korean%20male%20smiling%20casual%20portrait%20clean%20white%20background%20minimal%20headshot&width=40&height=40&seq=lb10&orientation=squarish",
      "https://readdy.ai/api/search-image?query=young%20korean%20female%20casual%20smile%20portrait%20minimal%20background%20headshot%20clean&width=40&height=40&seq=lb11&orientation=squarish",
      "https://readdy.ai/api/search-image?query=young%20korean%20female%20smiling%20casual%20portrait%20clean%20white%20background%20minimal%20headshot%20photography&width=40&height=40&seq=lb12&orientation=squarish",
    ],
    points: 2510,
    completedMissions: 4,
    badge: "",
    trend: "down",
  },
  {
    rank: 5,
    teamName: "AI 스타터팩",
    members: ["김민수", "이주연"],
    avatars: [
      "https://readdy.ai/api/search-image?query=young%20korean%20male%20professional%20portrait%20clean%20background%20minimal%20headshot%20warm&width=40&height=40&seq=lb13&orientation=squarish",
      "https://readdy.ai/api/search-image?query=young%20korean%20female%20professional%20portrait%20minimal%20background%20clean%20headshot&width=40&height=40&seq=lb14&orientation=squarish",
    ],
    points: 1890,
    completedMissions: 3,
    badge: "",
    trend: "up",
  },
];

const PERIOD_OPTIONS = ["이번 주", "이번 달", "전체"];

export default function TeamLeaderboard() {
  const [period, setPeriod] = useState("이번 주");

  return (
    <div className="space-y-5">
      {/* Period Filter */}
      <div className="bg-white rounded-2xl p-1.5 flex gap-1">
        {PERIOD_OPTIONS.map((p) => (
          <button
            key={p}
            onClick={() => setPeriod(p)}
            className={`flex-1 py-2 rounded-xl text-xs font-bold cursor-pointer whitespace-nowrap transition-all ${
              period === p ? "bg-[#191F28] text-white" : "text-[#8B95A1] hover:text-[#191F28]"
            }`}
          >
            {p}
          </button>
        ))}
      </div>

      {/* Top 3 Podium */}
      <div className="bg-white rounded-3xl p-6">
        <h3 className="text-base font-black text-[#191F28] mb-5">🏆 TOP 3 팀</h3>
        <div className="flex items-end justify-center gap-3">
          {/* 2nd */}
          <div className="flex-1 text-center">
            <div className="flex justify-center -space-x-1 mb-2">
              {LEADERBOARD_DATA[1].avatars.slice(0, 2).map((av, i) => (
                <img key={i} src={av} alt="" className="w-8 h-8 rounded-full border-2 border-white object-cover object-top" />
              ))}
            </div>
            <div className="bg-[#F2F4F6] rounded-2xl pt-4 pb-3 px-2">
              <div className="text-xl mb-1">🥈</div>
              <div className="text-xs font-black text-[#191F28] truncate">{LEADERBOARD_DATA[1].teamName}</div>
              <div className="text-sm font-black text-[#8B95A1] mt-1">{LEADERBOARD_DATA[1].points.toLocaleString()}P</div>
            </div>
          </div>
          {/* 1st */}
          <div className="flex-1 text-center -mt-4">
            <div className="flex justify-center -space-x-1 mb-2">
              {LEADERBOARD_DATA[0].avatars.slice(0, 3).map((av, i) => (
                <img key={i} src={av} alt="" className="w-9 h-9 rounded-full border-2 border-white object-cover object-top" />
              ))}
            </div>
            <div className="bg-[#191F28] rounded-2xl pt-5 pb-3 px-2">
              <div className="text-xl mb-1">👑</div>
              <div className="text-xs font-black text-white truncate">{LEADERBOARD_DATA[0].teamName}</div>
              <div className="text-sm font-black text-[#00D873] mt-1">{LEADERBOARD_DATA[0].points.toLocaleString()}P</div>
            </div>
          </div>
          {/* 3rd */}
          <div className="flex-1 text-center">
            <div className="flex justify-center -space-x-1 mb-2">
              {LEADERBOARD_DATA[2].avatars.slice(0, 2).map((av, i) => (
                <img key={i} src={av} alt="" className="w-8 h-8 rounded-full border-2 border-white object-cover object-top" />
              ))}
            </div>
            <div className="bg-[#F2F4F6] rounded-2xl pt-4 pb-3 px-2">
              <div className="text-xl mb-1">🥉</div>
              <div className="text-xs font-black text-[#191F28] truncate">{LEADERBOARD_DATA[2].teamName}</div>
              <div className="text-sm font-black text-[#8B95A1] mt-1">{LEADERBOARD_DATA[2].points.toLocaleString()}P</div>
            </div>
          </div>
        </div>
      </div>

      {/* Full Leaderboard */}
      <div className="bg-white rounded-3xl p-6">
        <h3 className="text-base font-black text-[#191F28] mb-4">전체 순위</h3>
        <div className="space-y-3">
          {LEADERBOARD_DATA.map((team) => (
            <div
              key={team.rank}
              className={`flex items-center gap-4 p-4 rounded-2xl transition-all ${
                team.rank === 1 ? "bg-[#191F28]" : "bg-[#F2F4F6]"
              }`}
            >
              {/* Rank */}
              <div
                className={`w-7 h-7 rounded-xl flex items-center justify-center text-sm font-black shrink-0 ${
                  team.rank === 1 ? "bg-[#00D873] text-white" : "bg-white text-[#191F28]"
                }`}
              >
                {team.rank}
              </div>

              {/* Avatars */}
              <div className="flex -space-x-1.5 shrink-0">
                {team.avatars.slice(0, 3).map((av, i) => (
                  <img key={i} src={av} alt="" className="w-7 h-7 rounded-full border-2 border-white object-cover object-top" />
                ))}
                {team.members.length > 3 && (
                  <div className="w-7 h-7 rounded-full border-2 border-white bg-[#E4E6EA] flex items-center justify-center text-[9px] font-bold text-[#8B95A1]">
                    +{team.members.length - 3}
                  </div>
                )}
              </div>

              {/* Name + Missions */}
              <div className="flex-1 min-w-0">
                <div className={`text-sm font-bold truncate ${team.rank === 1 ? "text-white" : "text-[#191F28]"}`}>
                  {team.badge} {team.teamName}
                </div>
                <div className={`text-xs mt-0.5 ${team.rank === 1 ? "text-white/50" : "text-[#8B95A1]"}`}>
                  미션 {team.completedMissions}개 완료
                </div>
              </div>

              {/* Points + Trend */}
              <div className="text-right shrink-0">
                <div className={`text-sm font-black ${team.rank === 1 ? "text-[#00D873]" : "text-[#191F28]"}`}>
                  {team.points.toLocaleString()}P
                </div>
                <div className="flex items-center justify-end gap-0.5 mt-0.5">
                  {team.trend === "up" && <i className="ri-arrow-up-s-line text-[#00D873] text-xs" />}
                  {team.trend === "down" && <i className="ri-arrow-down-s-line text-[#FF6B6B] text-xs" />}
                  {team.trend === "same" && <i className="ri-subtract-line text-[#8B95A1] text-xs" />}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
